import { ChangeDetectionStrategy, Component, Signal } from "@angular/core";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { LoaderService } from "../../services/loader/loader.service";

@Component({
  selector: "app-global-loader",
  standalone: true,
  imports: [MatProgressBarModule],
  templateUrl: "./global-loader.component.html",
  styleUrl: "./global-loader.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GlobalLoaderComponent {
  readonly isLoaderVisible: Signal<boolean>;

  constructor(private loaderService: LoaderService) {
    this.isLoaderVisible = this.loaderService.isLoaderVisible;
  }
}
